import {GET_ACTIVE_SUPPLIER, GET_SUPPLIER} from "@/store/action-types";
import {getSupplierOptions} from "@/api/purchase";

const SET_SUPPLIER = 'SET_SUPPLIER_STATE';
const SET_ACTIVE_SUPPLIER = 'SET_ACTIVE_SUPPLIER';

const state = {
  supplier: null,
  activeSupplier: null,
};

const mutations = {
  [SET_SUPPLIER](state, data) {
    state.supplier = data;
  },
  [SET_ACTIVE_SUPPLIER](state, data) {
    state.activeSupplier = data;
  }
};

const actions = {
  // 获取供应商资料下拉
  [GET_SUPPLIER]({commit, dispatch}) {
    return new Promise(((resolve, reject) => {
      getSupplierOptions(false)
        .then((data) => {
          commit(SET_SUPPLIER, data || []);
          resolve();
        })
        .catch(() => reject());
    }))
  },
  // 获取供应商资料启用下拉
  [GET_ACTIVE_SUPPLIER]({commit, dispatch}) {
    return new Promise(((resolve, reject) => {
      getSupplierOptions()
        .then((data) => {
          commit(SET_ACTIVE_SUPPLIER, data || []);
          resolve();
        })
        .catch(() => reject())
    }))
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
